import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft, ChevronRight, Package } from 'lucide-react';
import { RUNTIME_BACKEND_URL } from '../../lib/backendUrl';
import { findCategory } from '../../lib/vitrinCategories';

export const imgUrl = (f) => `${RUNTIME_BACKEND_URL}/api/hesap/teknik-servis/resim/${f}`;
export const price = (n) => `${Number(n || 0).toLocaleString('tr-TR')} ₺`;
export const conditionBadge = (d) => (d === 'sifir' ? ['Sıfır', 'bg-emerald-500'] : ['2. El', 'bg-amber-500']);

export const ProductGallery = ({ images }) => {
  const [i, setI] = useState(0);
  if (!images?.length) return <div className="aspect-square rounded-3xl bg-slate-100 flex items-center justify-center"><Package className="h-20 w-20 text-slate-300" /></div>;
  const go = (d) => setI(x => (x + d + images.length) % images.length);
  return (
    <div className="space-y-3" data-testid="product-gallery">
      <div className="relative aspect-square rounded-3xl overflow-hidden bg-white border">
        <img src={imgUrl(images[i])} alt="" className="w-full h-full object-contain" />
        {images.length > 1 && (
          <>
            <button onClick={() => go(-1)} className="absolute left-3 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white/90 shadow flex items-center justify-center" data-testid="gallery-prev"><ChevronLeft className="h-5 w-5" /></button>
            <button onClick={() => go(1)} className="absolute right-3 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white/90 shadow flex items-center justify-center" data-testid="gallery-next"><ChevronRight className="h-5 w-5" /></button>
          </>
        )}
      </div>
      {images.length > 1 && (
        <div className="flex gap-2 overflow-x-auto pb-1">
          {images.map((f, k) => (
            <button key={f} onClick={() => setI(k)} className={`w-16 h-16 flex-shrink-0 rounded-xl overflow-hidden border-2 ${k === i ? 'border-slate-900' : 'border-transparent opacity-70'}`}>
              <img src={imgUrl(f)} alt="" className="w-full h-full object-cover" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export const specRows = (item, custom) => {
  const cat = findCategory(item.cihaz_turu, custom);
  const rows = cat.fields.map(f => [f.label, f.key === 'imei' || f.key === 'seri_no' ? item[f.key] : (item.ekstra || {})[f.key]]).filter(([, v]) => v);
  return { cat, rows };
};

export const ProductCard = ({ item, custom }) => {
  const [label, cls] = conditionBadge(item.durum);
  return (
    <Link to={`/cihaz/${item.id}`} className="group block bg-white rounded-2xl border overflow-hidden hover:shadow-xl hover:-translate-y-1 transition-[transform,box-shadow] duration-300" data-testid={`vitrin-card-${item.id}`}>
      <div className="relative aspect-square bg-slate-50">
        {item.resimler?.[0] ? <img src={imgUrl(item.resimler[0])} alt="" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
          : <div className="w-full h-full flex items-center justify-center"><Package className="h-12 w-12 text-slate-300" /></div>}
        <span className={`absolute top-3 left-3 text-white text-[11px] font-bold px-2.5 py-1 rounded-full ${cls}`}>{label}</span>
      </div>
      <div className="p-4">
        <p className="text-[11px] uppercase tracking-wider text-slate-400">{findCategory(item.cihaz_turu, custom).label}</p>
        <p className="font-semibold text-slate-900 truncate">{item.marka} {item.model}</p>
        <p className="text-lg font-bold text-slate-900 mt-1">{price(item.satis_fiyati)}</p>
      </div>
    </Link>
  );
};
